/* eslint-disable radix */
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
	FormGroup,
	Label,
	Button,
	Row,
	Col,
	Input,
	Card,
} from 'reactstrap';
import * as commonActions from '../../app/common/common.action';
import IntlMessage from '../../helpers/intlMessage';
import { httpRequest } from '@util/api-common.util';
import SelectAsyncComponent from '@componentes/select/select-async.component';
import SelectComponent from '@componentes/select/select.component';

export default function ModalNovoPedido({
	intl,
	isOpen,
	setOpenModalNovoPedido,
}) {
	const { messages } = intl;
	const dispatch = useDispatch();
	const [modalAberto, setModalAberto] = useState(isOpen);
	const [listaProcedimentos, setListaProcedimentos] = useState([]);
	const [listaPacientes, setListaPacientes] = useState([]);
	const [listaConvenios, setListaConvenios] = useState([]);
	const [listaMedicos, setListaMedicos] = useState([]);
	const [listaTiposExames, setListaTiposExames] = useState([]);
	const [listaExames, setListaExames] = useState([]);
	const [listaSetores, setListaSetores] = useState([]);
	const [procedimentoSelecionado, setProcedimentoSelecionado] = useState();
	const [pacienteSelecionado, setPacienteSelecionado] = useState();
	const [convenioSelecionado, setConvenioSelecionado] = useState();
	const [medicoSolicitante, setMedicoSolicitante] = useState();
	const [medicoRevisor, setMedicoRevisor] = useState();
	const [medicoExecutante, setMedicoExecutante] = useState();
	const [tipoExameSelecionado, setTipoExameSelecionado] = useState();
	const [exameSelecionado, setExameSelecionado] = useState();
	const [setorSelecionado, setSetorSelecionado] = useState();
	const [codigoAMB, setCodigoAMB] = useState();
	const [observacoes, setObservacoes] = useState();
	const [status, setStatus] = useState();
	const [leito, setLeito] = useState();

	useEffect(() => {
		setModalAberto(isOpen);
	}, [isOpen]);

	useEffect(() => {
		httpRequest('Procedimentos', 'GET').then((res) => {
			setListaProcedimentos(res.data);
		});
		httpRequest('Pacientes', 'GET').then((res) => {
			setListaPacientes(res.data);
		});
		httpRequest('Convenios', 'GET').then((res) => {
			setListaConvenios(res.data);
		});
		httpRequest('Medicos', 'GET').then((res) => {
			setListaMedicos(res.data);
		});
		httpRequest('TiposExame', 'GET').then((res) => {
			setListaTiposExames(res.data);
		});
		httpRequest('Exames', 'GET').then((res) => {
			setListaExames(res.data);
		});
		httpRequest('Setores', 'GET').then((res) => {
			setListaSetores(res.data);
		});
	}, []);

	const listStatus = [
		{ value: 'I', label: 'Interno' },
		{ value: 'E', label: 'Externo' },
		{ value: 'U', label: 'Urgente' },
		{ value: 'A', label: 'Ambulatório' },
	];

	const newLaudo = () => {
		const timeElapsed = Date.now();
		const today = new Date(timeElapsed);
		let body = {
			procedimentoID: procedimentoSelecionado
				? procedimentoSelecionado.value
				: 0,
			pacienteID: pacienteSelecionado ? pacienteSelecionado.value : 0,
			convenioID: convenioSelecionado ? convenioSelecionado.value : 0,
			medicoSolicitanteID: medicoSolicitante ? medicoSolicitante.value : 0,
			medicoExecutanteID: medicoExecutante ? medicoExecutante.value : 0,
			medicoRevisorID: medicoRevisor ? medicoRevisor.value : 0,
			tipoExameID: tipoExameSelecionado ? tipoExameSelecionado.value : 0,
			exameID: exameSelecionado ? exameSelecionado.value : 0,
			codigoAMB: codigoAMB ? codigoAMB : '',
			observacoes: observacoes ? observacoes : '',
			dataDUM: today ? today.toISOString() : '',
			setorCodigo: setorSelecionado ? setorSelecionado.value : 0,
			status: status ? status.value : '',
			leito: leito ? leito : '',
		};
		httpRequest('Laudos', 'POST', body).then((res) => {
			dispatch(commonActions.showAlerta('sucesso', res.message, 2000, `550px`));
			resetValues();
			setOpenModalNovoPedido(!isOpen);
		});
	};

	const resetValues = () => {
		setProcedimentoSelecionado();
		setPacienteSelecionado();
		setConvenioSelecionado();
		setMedicoSolicitante();
		setMedicoRevisor();
		setMedicoExecutante();
		setTipoExameSelecionado();
		setExameSelecionado();
		setSetorSelecionado();
		setCodigoAMB();
		setObservacoes();
		setStatus();
		setLeito();
	};

	const toggle = () => {
		resetValues();
		setOpenModalNovoPedido(!isOpen);
	};

	return (
		<Modal className="modal-xl" centered isOpen={modalAberto} toggle={toggle}>
			<ModalHeader toggle={toggle}>Novo pedido</ModalHeader>
			<ModalBody>
				<Card style={{ padding: '20px' }}>
					<Row>
						<Col xl="12">
							<FormGroup>
								<Label>
									<IntlMessage id="dashboards.general.procedure" />
								</Label>
								<SelectAsyncComponent
									options={listaProcedimentos}
									value={procedimentoSelecionado}
									onChange={(e) => {
										setProcedimentoSelecionado(e);
									}}
									placeholder={messages['general.requestsPanel.selectAnOption']}
								/>
							</FormGroup>
						</Col>
					</Row>
					<Row>
						<Col xl="6">
							<FormGroup>
								<Label>
									<IntlMessage id="dashboards.general.pacient" />
								</Label>
								<SelectAsyncComponent
									options={listaPacientes}
									value={pacienteSelecionado}
									onChange={(e) => {
										setPacienteSelecionado(e);
									}}
									placeholder={messages['general.requestsPanel.selectAnOption']}
								/>
							</FormGroup>
						</Col>
						<Col xl="6">
							<FormGroup>
								<Label>
									<IntlMessage id="dashboards.general.healthInsurance" />
								</Label>
								<SelectComponent
									options={listaConvenios}
									value={convenioSelecionado}
									onChange={(e) => {
										setConvenioSelecionado(e);
									}}
									placeholder={messages['general.requestsPanel.selectAnOption']}
								/>
							</FormGroup>
						</Col>
					</Row>
					<Row>
						<Col xl="12">
							<FormGroup>
								<Label>
									<IntlMessage id="dashboards.general.requestingDoctor" />
								</Label>
								<SelectAsyncComponent
									options={listaMedicos}
									value={medicoSolicitante}
									onChange={(e) => {
										setMedicoSolicitante(e);
									}}
									placeholder={messages['general.requestsPanel.selectAnOption']}
								/>
							</FormGroup>
						</Col>
					</Row>
					<Row>
						<Col xl="6">
							<FormGroup>
								<Label>
									<IntlMessage id="dashboards.reports.examType" />
								</Label>
								<SelectAsyncComponent
									options={listaTiposExames}
									value={tipoExameSelecionado}
									onChange={(e) => {
										setTipoExameSelecionado(e);
									}}
									placeholder={messages['general.requestsPanel.selectAnOption']}
								/>
							</FormGroup>
						</Col>
						<Col xl="6">
							<FormGroup>
								<Label>
									<IntlMessage id="dashboards.reports.exam" />
								</Label>
								<SelectAsyncComponent
									options={listaExames}
									value={exameSelecionado}
									onChange={(e) => {
										setExameSelecionado(e);
									}}
									placeholder={messages['general.requestsPanel.selectAnOption']}
								/>
							</FormGroup>
						</Col>
					</Row>
					<Row>
						<Col xl="12">
							<FormGroup className="confirmar-primary">
								<Label>Código AMB</Label>
								<Input
									type="text"
									value={codigoAMB}
									maxLength="14"
									onChange={(e) => setCodigoAMB(e.target.value)}
								/>
							</FormGroup>
						</Col>
					</Row>
					<Row>
						<Col xl="12">
							<FormGroup className="confirmar-primary">
								<Label>
									<IntlMessage id="dashboards.examDetail.comments" />
								</Label>
								<Input
									value={observacoes}
									bsSize="sm"
									type="textarea"
									onChange={(e) => setObservacoes(e.target.value)}
								/>
							</FormGroup>
						</Col>
					</Row>
					<Row>
						<Col xl="6">
							<FormGroup>
								<Label>
									<IntlMessage id="dashboards.examDetail.performingPhysician" />
								</Label>
								<SelectAsyncComponent
									options={listaMedicos}
									value={medicoExecutante}
									onChange={(e) => {
										setMedicoExecutante(e);
									}}
									placeholder={messages['general.requestsPanel.selectAnOption']}
								/>
							</FormGroup>
						</Col>
						<Col xl="6">
							<FormGroup>
								<Label>
									<IntlMessage id="dashboards.general.medicalReviewer" />
								</Label>
								<SelectAsyncComponent
									options={listaMedicos}
									value={medicoRevisor}
									onChange={(e) => {
										setMedicoRevisor(e);
									}}
									placeholder={messages['general.requestsPanel.selectAnOption']}
								/>
							</FormGroup>
						</Col>
					</Row>
					<Row>
						<Col xl="3">
							<FormGroup>
								<Label>Setor</Label>
								<SelectComponent
									options={listaSetores}
									value={setorSelecionado}
									onChange={(e) => {
										setSetorSelecionado(e);
									}}
									placeholder={messages['general.requestsPanel.selectAnOption']}
								/>
							</FormGroup>
						</Col>
						<Col xl="3">
							<FormGroup>
								<Label>
									<IntlMessage id="dashboards.reports.status" />
								</Label>
								<SelectComponent
									options={listStatus}
									value={status}
									onChange={(e) => {
										setStatus(e);
									}}
									placeholder={messages['general.requestsPanel.selectAnOption']}
								/>
							</FormGroup>
						</Col>
						<Col xl="6">
							<FormGroup className="confirmar-primary">
								<Label>Leito</Label>
								<Input
									value={leito}
									type="text"
									onChange={(e) => setLeito(e.target.value)}
								/>
							</FormGroup>
						</Col>
					</Row>
				</Card>
			</ModalBody>
			<ModalFooter>
				<Button onClick={toggle} className="button-cancel" color="secondary">
					<IntlMessage id="dashboards.examDetails.cancel" />
				</Button>
				<Button
					className="button-confirm"
					onClick={() => newLaudo()}
					color="primary"
				>
					<IntlMessage id="dashboards.examDetails.confirm" />
				</Button>
			</ModalFooter>
		</Modal>
	);
}



// WEBPACK FOOTER //
// ./src/componentes/modalNovoPedido/index.jsx